import React from 'react'
import { browserHistory } from 'react-router'
import {loginHelper} from '../../helpers/Login/'

export default class LoginCard extends React.Component {
    logUserOn(e){
        e.preventDefault();
        loginHelper.logUserOn();
    }

    vendorLogin(e){
        e.preventDefault();
        browserHistory.replace('/vendor/login');
    }

    signup(e) {
        e.preventDefault();
        browserHistory.replace('/signup');
    }

    forgotPassworf(e) {
        e.preventDefault();
        browserHistory.replace('/forgot');
    }


    render(){
        return (
            <div class="new-login-card">
                <div class="">
                    <h4 class="title login-right-panel-text">Welcome to Leasey</h4><p class="category" onClick={this.signup}>New here?<span> </span><a class="register">Create an account</a></p>
                </div>
                <div class="login-box-body">
                    <p class="login-box-msg"><span></span></p>
                    <form action="" method="post" id="theForm" onsubmit="return false;">
                        <div class="form-group has-feedback">
                            <input class="form-control" type="text" name="log" id="username" placeholder="Email or Username" />
                            <i class="form-control-feedback fa fa-user"></i>
                        </div>
                        <div class="form-group has-feedback no-margin-bottom">
                            <input type="password" name="pwd" class="form-control" id="password" placeholder="Enter Password" />
                            <i class="form-control-feedback fa fa-lock"></i>
                        </div>
                        <div class="row login-inputs">
                            <div>
                                <div class="loading"><i class="fa fa-cog fa-spin"></i></div>
                                <button type="submit" onClick={this.logUserOn} name="submit" id="login" class="login-input btn btn-login-fill btn-block btn-flat" >Login</button>
                            </div>
                            <div class="login-input text-right footer-login">
                                <div>
                                    <a onClick={this.forgotPassworf} class="register">Forgot Password?</a>
                                </div>
                            </div>
                        </div>
                        <div class="row login-or">
                            <div class="text-center footer-login no-margin"><span>OR</span></div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 text-center footer-login no-margin">
                                <p>
                                    Are you a vendor? <a onClick={this.vendorLogin} class="register">Login</a>
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 text-center footer-login no-margin-top">
                                <p>
                                    Don't have an account? <a onClick={this.signup} class="register">Sign Up</a>
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Login/LoginCard.jsx